/* global initMobileChat */
angular
    .module('WizApp')
    .controller('CookieBannerController', [
        'CookiesConsentService',
        function (CookiesConsentService) {
            var consents = null;
            var initiated = false;
            var bannerShouldBeHidden = null;

            const vm = this;

            vm.sendAllConsent = sendAllConsent;
            vm.getConsents = getConsents;
            vm.hideCookieBanner = hideCookieBanner;
            vm.setCookieBannerShown = setCookieBannerShown;
            vm.localeStorageUrlIsIdentical = localeStorageUrlIsIdentical;

            vm.allConsent = {
                connect_facebook: true,
                connect_google: true,
                analytics_facebook_pixel: true,
                analytics_google: true,
                analytics_hotjar: true
            };

            /*----------------------------*\
                functions
            \*----------------------------*/

            function sendAllConsent() {
                CookiesConsentService.setCookiesConsent(vm.allConsent);
                bannerShouldBeHidden = true;
                if (initMobileChat) {
                    initMobileChat();
                }
            }

            function getConsents() {
                return CookiesConsentService.getCookiesConsent();
            }

            function hideCookieBanner() {
                if (!initiated) {
                    return true;
                }

                if (bannerShouldBeHidden !== null) {
                    return bannerShouldBeHidden;
                }

                if (localStorage.getItem('cookie_banner_shown') && !vm.localeStorageUrlIsIdentical() && document.referrer.search(/wizbii/) !== -1) {
                    vm.sendAllConsent();
                    bannerShouldBeHidden = true;
                    return bannerShouldBeHidden;
                }

                bannerShouldBeHidden = consents !== null;

                if (!bannerShouldBeHidden) {
                    vm.setCookieBannerShown();
                }

                return bannerShouldBeHidden;
            }

            function setCookieBannerShown() {
                localStorage.setItem('cookie_banner_shown', window.location.href);
            }

            function localeStorageUrlIsIdentical() {
                return localStorage.getItem('cookie_banner_shown') === window.location.href;
            }

            /*----------------------------*\
                init
            \*----------------------------*/

            vm.getConsents().then(data => {
                consents = data;
                initiated = true;
            });
        }
    ])
;
